import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';

export const Access = (props) => {
    const navigate = useNavigate();
    const administracionLogo = localStorage.getItem('administracionLogo') || 'expensas360.png';

    const goDashboard = () => {
        navigate('/');
    };

    return (
        <div className="exception-body accessdenied">
            <div className="exception-panel">
                <h1>Acceso</h1>
                <h3>Denegado</h3>
                <p>You are not allowed to view this page.</p>
                <Button type="button" label="Go back to home" onClick={goDashboard}></Button>
            </div>
            <div className="exception-footer">
                <img src={`assets/layout/images/administradoras/${administracionLogo}`} className="exception-logo" alt="exception-logo" />
            </div>
        </div>
    );
};
